import { useState, useEffect } from 'react'
import Block from '../../../components/Block/Block'
import NewsCard from '../../../components/NewsCard/NewsCard'
import NewsModal from '../../../components/NewsModal/NewsModal' // Import the modal
import Button from '../../../components/Button/Button'
import FadeIn from '../../../components/FadeIn/FadeIn'
import { fetchNews } from '../../../services/api'
import style from './newsgridblock.module.scss'
import PaginationControl from '../../../components/PaginationControl/PaginationControl'

const NewsGridBlock = () => {
    const [news, setNews] = useState([])
    const [loading, setLoading] = useState(true)
    const [pagination, setPagination] = useState({})
    const [currentPage, setCurrentPage] = useState(1)
    const [selectedNews, setSelectedNews] = useState(null) // State for selected news

    useEffect(() => {
        const loadNews = async () => {
            setLoading(true)
            try {
                const { data, pagination } = await fetchNews({
                    page: currentPage,
                    pageSize: 3
                });
                // Properly handle the Strapi response structure
                const formattedData = data.map(item => ({
                    id: item.id,
                    title: item.attributes.Title,
                    text: item.attributes.Text,
                    publishedAt: item.attributes.publishedAt,
                    createdAt: item.attributes.createdAt,
                    imageUrl: item.attributes.Image?.data?.attributes?.url
                        ? `${item.attributes.Image.data.attributes.url}`
                        : null,
                    // Include the full Image object for modal
                    Image: item.attributes.Image,
                    // Include other attributes that might be needed
                    content: item.attributes.Text,
                    description: item.attributes.Text
                }));
                setNews(formattedData)
                setPagination(pagination)
            } catch (error) {
                console.error('Failed to load news:', error)
            } finally {
                setLoading(false)
            }
        }

        loadNews()
    }, [currentPage])

    // Handle news card click
    const handleNewsClick = (newsItem) => {
        // Prepare news data for modal
        const newsData = {
            id: newsItem.id,
            Title: newsItem.title,
            Text: newsItem.text,
            content: newsItem.text,
            description: newsItem.text,
            publishedAt: newsItem.publishedAt,
            createdAt: newsItem.createdAt,
            Image: newsItem.Image,
            image: newsItem.imageUrl,
            // Include other properties that your NewsModal expects
            title: newsItem.title,
            text: newsItem.text
        };
        setSelectedNews(newsData);
    };

    // Close news modal
    const handleCloseModal = () => {
        setSelectedNews(null);
    };

    return (
        <>
            <Block
                flexDirection='column'
                justifyContent='center'
                alignItems='start'
                width="75%"
                height='fit-content'
                background="rgba(255, 255, 255, 0.85)"
                header='НОВОСТИ'
            >
                <FadeIn>
                    <div className={style.content}>
                        <div className={style.wrapperFilter}>
                        </div>
                        <div className={style.newsgrid}>
                            {news.map(item => (
                                <NewsCard
                                    key={item.id}
                                    id={item.id}
                                    title={item.title}
                                    text={item.text}
                                    date={new Date(item.publishedAt).toLocaleDateString()}
                                    image={item.imageUrl}
                                    onClick={() => handleNewsClick(item)}
                                />
                            ))}
                        </div>
                        <div className={style.wrapperBtn}>
                            <PaginationControl
                                page={currentPage}
                                setPage={setCurrentPage}
                                pageCount={pagination.pageCount}
                            />
                        </div>
                    </div>
                </FadeIn>
            </Block>

            {/* News Modal */}
            <NewsModal
                news={selectedNews}
                onClose={handleCloseModal}
            />
        </>
    )
}

export default NewsGridBlock